import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { canEditProfile } from '../../../../library/Core/SmartFunctions';
import SessionContext from '../../../../library/Core/SessionContext';
import AssignSession from './AssignSession';
import SendMessage from './SendMessage';

const Preferences3c = () => {
    const { state, dispatch } = useContext(SmartContext);
    const model = state.internal.model;
    const { id, pageName } = useParams();
    const numberStrings = ['First', 'Second', 'Third'];
    //const classCode = parseInt(state?.data?.classCode);
    const educationPreferenceInfo = state?.data?.educationPreferenceInfo;
    const navigate = useNavigate();
    const { sessionState }: any = useContext(SessionContext);

    if (sessionState?.userTypeCode === 'STUDENT' && sessionState?.profileStatusCode === 'PREFERENCES_INCOMPLETE') {
        window.location.href = `/alumni/${sessionState?.id}/student-preference`;
        return null; // Redirection is initiated, so no need to render further
    }

    return (
        // <div className="tab-pane" id="pills-preferences" role="tabpanel" aria-labelledby="pills-preferences-tab">
        <div>
            <div className="preferences-detail tab-white-block">
                {canEditProfile(model.id, sessionState) && (
                    <a className="pencil-edit" role="button" onClick={() => navigate(`/alumni/${id}/student-preference`)}></a>
                )}
                <div className='row g-5'>
                    <div className='col-12'>
                        <div className='row g-2 align-items-center'>
                            <div className='col'>
                                <h3 className='font-20 font-500 mb-2'>Filled By Student</h3>
                            </div>
                            {/* <div className='col-auto'>
                                <a className="pencil-edit position-static" role="button" onClick={() => navigate(`/alumni/${id}/student-preference`)}></a>
                            </div> */}
                        </div>
                        
                        <div className='bg-gray-f2 p-4 radius-6'>
                            <div className="customRow">
                                <div className="customRow-header">
                                    <div className="icon icon-global"></div>
                                    <div className="customRow-header-title">
                                        <span className="font-20 font-500">Country</span>
                                    </div>
                                </div>
                                <div className="customRow-detail">
                                    <div className="row g-3">
                                        {!educationPreferenceInfo?.isCountryChoiceSkipped &&
                                            model.locationPreferences.map((item: any, index: number) => (
                                                <div key={item.countryName} className="col-md-4">
                                                    <div className="d-flex flex-column">
                                                        <div className="font-16 font-400 lineHeight-22 mb-1">{numberStrings[index]} Preference</div>
                                                        <div className="font-18 font-500 lineHeight-22">{item.countryName}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        {educationPreferenceInfo?.isCountryChoiceSkipped && <div>I Havn't Finalized Country Yet</div>}
                                    </div>
                                </div>
                            </div>

                    <div className="customRow">
                        <div className="customRow-header">
                            <div className="icon icon-book-white"></div>
                            <div className="customRow-header-title">
                                <span className="font-20 font-500">Course</span>
                            </div>
                        </div>
                        <div className="customRow-detail">
                            <div className="row g-3">
                                {!educationPreferenceInfo?.isCareerChoiceSkipped &&
                                    model.fieldOfStudyPreferences.map((item: any, index: number) => (
                                        <div key={item.fieldOfStudyName} className="col-md-4">
                                            {item.fieldOfStudyName && (
                                                <div className="d-flex flex-column">
                                                    <div className="font-16 font-400 lineHeight-22 mb-1">{numberStrings[index]} Preference</div>
                                                    <div className="font-18 font-500 lineHeight-22">{item.fieldOfStudyName}</div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                {educationPreferenceInfo?.isCareerChoiceSkipped && <div>I haven't finalized the course yet</div>}
                            </div>
                        </div>
                    </div>

                    <>
                        <div className="customRow">
                            <div className="customRow-header">
                                <div className="icon icon-university-college"></div>
                                <div className="customRow-header-title">
                                    <span className="font-20 font-500">College</span>
                                </div>
                            </div>
                            <div className="customRow-detail">
                                <div className="row g-3">
                                    {!educationPreferenceInfo?.isCollegeChoiceSkipped &&
                                        model.universityPreferences.map((item: any, index: number) => (
                                            <div key={item.universityName} className="col-md-4">
                                                <div className="d-flex flex-column">
                                                    <div className="font-16 font-400 lineHeight-22 mb-1">{numberStrings[index]} Preference</div>
                                                    <div className="font-18 font-500 lineHeight-22">{item.universityName}</div>
                                                </div>
                                            </div>
                                        ))}
                                    {educationPreferenceInfo?.isCollegeChoiceSkipped && <div>I haven't finalized the college yet</div>}
                                </div>
                            </div>
                        </div>

                        {/* <div>
                            <span>Planning to join in :</span>{' '}
                            <span className="font-18 font-500">
                                {model?.preferredProgramStartOn != '' ? model?.preferredProgramStartOn : '-'}
                            </span>
                        </div> */}
                    </>
                        </div>
                        
                    </div>
                    
                    <div className='col-12'>
                        <div className='row g-2 align-items-center'>
                            <div className='col'>
                                <h3 className='font-20 font-500 mb-2'>Counsellors Inputs</h3>
                            </div>
                            
                                <a className="pencil-edit" role="button" onClick={() => navigate(`/alumni/${id}/counsellor-student-preference`)}></a>
                            
                            {/* <div className='col-auto'>
                                <a className="pencil-edit position-static" role="button" onClick={() => navigate(`/alumni/${id}/student-preference`)}></a>
                            </div> */}
                        </div>
                       
                        <div className='bg-gray-f2 p-4 radius-6'>
                                 <div className="customRow">
                                <div className="customRow-header">
                                    <div className="icon icon-global"></div>
                                    <div className="customRow-header-title">
                                        <span className="font-20 font-500">Country</span>
                                    </div>
                                </div>
                                <div className="customRow-detail">
                                    <div className="row g-3">
                                        {!educationPreferenceInfo?.isCountryChoiceSkipped &&
                                            model.locationPreferences.map((item: any, index: number) => (
                                                <div key={item.countryName} className="col-md-4">
                                                    <div className="d-flex flex-column">
                                                        <div className="font-16 font-400 lineHeight-22 mb-1">{numberStrings[index]} Preference</div>
                                                        <div className="font-18 font-500 lineHeight-22">{item.countryName}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        {educationPreferenceInfo?.isCountryChoiceSkipped && <div>I Havn't Finalized Country Yet</div>}
                                    </div>
                                </div>
                            </div>

                    <div className="customRow">
                        <div className="customRow-header">
                            <div className="icon icon-book-white"></div>
                            <div className="customRow-header-title">
                                <span className="font-20 font-500">Course</span>
                            </div>
                        </div>
                        <div className="customRow-detail">
                            <div className="row g-3">
                                {!educationPreferenceInfo?.isCareerChoiceSkipped &&
                                    model.fieldOfStudyPreferences.map((item: any, index: number) => (
                                        <div key={item.fieldOfStudyName} className="col-md-4">
                                            {item.fieldOfStudyName && (
                                                <div className="d-flex flex-column">
                                                    <div className="font-16 font-400 lineHeight-22 mb-1">{numberStrings[index]} Preference</div>
                                                    <div className="font-18 font-500 lineHeight-22">{item.fieldOfStudyName}</div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                {educationPreferenceInfo?.isCareerChoiceSkipped && <div>I haven't finalized the course yet</div>}
                            </div>
                        </div>
                    </div>

                    <>
                        <div className="customRow">
                            <div className="customRow-header">
                                <div className="icon icon-university-college"></div>
                                <div className="customRow-header-title">
                                    <span className="font-20 font-500">College</span>
                                </div>
                            </div>
                            <div className="customRow-detail">
                                <div className="row g-3">
                                    {!educationPreferenceInfo?.isCollegeChoiceSkipped &&
                                        model.universityPreferences.map((item: any, index: number) => (
                                            <div key={item.universityName} className="col-md-4">
                                                <div className="d-flex flex-column">
                                                    <div className="font-16 font-400 lineHeight-22 mb-1">{numberStrings[index]} Preference</div>
                                                    <div className="font-18 font-500 lineHeight-22">{item.universityName}</div>
                                                </div>
                                            </div>
                                        ))}
                                    {educationPreferenceInfo?.isCollegeChoiceSkipped && <div>I haven't finalized the college yet</div>}
                                </div>
                            </div>
                        </div>

                        {/* <div>
                            <span>Planning to join in :</span>{' '}
                            <span className="font-18 font-500">
                                {model?.preferredProgramStartOn != '' ? model?.preferredProgramStartOn : '-'}
                            </span>
                        </div> */}
                    </> 
                        </div>


                        {/* <div className='row g-3 mt-3'>
                            <div className='col-auto'>
                                <AssignSession className='btn-nostyle' btnText='Assign a session'/>
                            </div>
                            <div className='col-auto'>
                                <SendMessage className='btn-nostyle' btnText='Send Message'/>
                            </div>
                        </div> */}

                        

                        
                       
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preferences3c;
